import React from "react";
import "./Account_tab.css";

import Account_tab_card from "./account_tab_card/Account_tab_card";
import {
  faComment,
  faEnvelope,
  faFile,
} from "@fortawesome/free-regular-svg-icons";
import {
  faLocationDot,
  faLock,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

function Account_tab() {
  const accountTabsData = [
    {
      heading_title: "Orders & returns",
      icon: faFile,
      card_title: "View and track your orders",
      link_text: "View",
      link: "/luxury/all-orders",
    },
    {
      heading_title: "Communication preferences",
      icon: faComment,
      card_title: "Stay up to date with the latest updates",
      link_text: "View",
      link: "/luxury/communication-preferences",
    },
    {
      heading_title: "Manage address",
      icon: faLocationDot,
      card_title: "Add / Update address",
      link_text: "Manage",
      link: "/luxury/manage-address",
    },
    {
      heading_title: "Keep your email address updated",
      icon: faEnvelope,
      card_title: "To update your email",
      link_text: "Update",
       link: "/luxury/update-email-address"
    },
    {
      heading_title: "Keep your phone number updated",
      icon: faPhone,
      card_title: "To update contact number",
      link_text: "Update",
       link: "/luxury/update-contact-number"
    },
    {
      heading_title: "Update password",
      icon: faLock,
      card_title: "Keep your account secure",
      link_text: "Update",
        link: "/luxury/update-password"
    },
  ];

  return (
    <>
      <section className="Account_tab">
        <div className="custom_container">
          <div className="heading_hodler">
            <h2 className="titile_text">YOUR ACCOUNT</h2>
          </div>

          <div className="row">
            {accountTabsData.map((item, index) => (
              <div className="col-lg-4 col-md-6 col-sm-6 mb-4" key={index}>
                <Account_tab_card
                  link={item.link}
                  heading_title={item.heading_title}
                  icon={item.icon}
                  card_title={item.card_title}
                  link_text={item.link_text}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Account_tab;
